import React from 'react';
import {
  Home, HomeOutlined,
  Person, PersonOutline,
  Settings, SettingsOutlined,
} from '@mui/icons-material';
import { SideBarNav } from '@uplift/types';
import { isRestricted } from '@uplift/utils';
import { l10nEnService } from '@uplift/services';
import { ROUTING_CONFIG } from '@uplift/constants';
import { useL10n } from '@uplift/hooks';

import { useCurrentuser } from '@uplift/contexts';
import {
  Payments,
  PaymentsOutlined,
  HealthAndSafety,
  HealthAndSafetyOutlined,
} from '@uplift/icons';
import { CampusPlan } from '@uplift/api';
import { useCurrentStudentDetails } from '@uplift/queries';


const useMainNavConfig = (l10n: typeof l10nEnService): SideBarNav[] => {
  const me = useCurrentuser();
  const currentStudent = useCurrentStudentDetails({ suspense: true });
  const restricted = isRestricted(me);

  return [
    {
      name: l10n.pages.main,
      to: ROUTING_CONFIG.main,
      icon: <HomeOutlined />,
      activeIcon: <Home />,
      restricted: restricted,
    },
    {
      name: l10n.payments.payments,
      to: ROUTING_CONFIG.payments,
      exact: false,
      icon: <PaymentsOutlined />,
      activeIcon: <Payments />,
      hidden: [ CampusPlan.flex, CampusPlan.complete ].includes(currentStudent?.higherEdOrg?.contract?.plan?.type)
    },
    {
      name: l10n.payments.insurance,
      to: ROUTING_CONFIG.insurance,
      exact: true,
      icon: <HealthAndSafetyOutlined />,
      activeIcon: <HealthAndSafety />,
    },
    {
      name: l10n.pages.yourCareTeam,
      to: ROUTING_CONFIG.careTeam,
      icon: <PersonOutline />,
      activeIcon: <Person />,
      exact: false,
      restricted: restricted,
    },
    {
      name: l10n.pages.accountSettings,
      to: ROUTING_CONFIG.settings,
      icon: <SettingsOutlined />,
      activeIcon: <Settings />,
      exact: false,
      restricted: restricted,
    },
  ].filter((el) => !el.hidden);
};

export const useLayoutConf = () => {
  const l10n = useL10n();
  const mainNavConfig = useMainNavConfig(l10n);

  return {
    mainNavConfig
  };
};
